import React from "react";
import { Card, CardContent } from "@/components/ui/card";

interface SettingsContentWrapperProps {
  children: React.ReactNode;
  title: string;
  description?: string;
}

interface SettingsBlockProps {
  icon: React.ReactNode;
  title: string;
  iconBgColor?: string;
  iconTextColor?: string;
  children: React.ReactNode;
}

export const SettingsBlock: React.FC<SettingsBlockProps> = ({
  icon,
  title,
  iconBgColor = "bg-amber-100",
  iconTextColor = "text-amber-500",
  children,
}) => {
  return (
    <Card className="border rounded-lg">
      <CardContent className="p-6">
        <div className="space-y-6">
          <div className="flex items-center gap-2 mb-4">
            <div className={`p-2 ${iconBgColor} rounded-md ${iconTextColor}`}>
              {icon}
            </div>
            <h3 className="text-lg font-medium">{title}</h3>
          </div>
          {children}
        </div>
      </CardContent>
    </Card>
  );
};

const SettingsContentWrapper: React.FC<SettingsContentWrapperProps> = ({
  children,
  title,
  description,
}) => {
  return (
    <div className="w-full">
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-gray-900">{title}</h2>
        {description && <p className="text-gray-600 mt-2">{description}</p>}
      </div>
      <div className="space-y-6">{children}</div>
    </div>
  );
};

export default SettingsContentWrapper;
